import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enTranslation from "./locales/en.json";
import esTranslation from "./locales/es.json";
import itTranslation from "./locales/it.json";
import frTranslation from "./locales/fr.json";
import deTranslation from "./locales/de.json";


i18n.use(initReactI18next).init({
  lng: "en",
  resources: {
    en: {
      translation: enTranslation,
    },
    es: {
      translation: esTranslation,
    },
    it: {
      translation: itTranslation,
    },
    fr: {
      translation: frTranslation,
    },
    de: {
      translation: deTranslation,
    },
   
  },
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;